"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shops = exports.ShopLanguages = exports.toBusinessCentralCompany = exports.ImportSource = void 0;
var importSource_enum_1 = require("./importSource.enum");
Object.defineProperty(exports, "ImportSource", { enumerable: true, get: function () { return importSource_enum_1.default; } });
var importSource_enum_2 = require("./importSource.enum");
Object.defineProperty(exports, "toBusinessCentralCompany", { enumerable: true, get: function () { return importSource_enum_2.toBusinessCentralCompany; } });
var shop_languages_1 = require("./shop-languages");
Object.defineProperty(exports, "ShopLanguages", { enumerable: true, get: function () { return shop_languages_1.default; } });
var shops_1 = require("./shops");
Object.defineProperty(exports, "Shops", { enumerable: true, get: function () { return shops_1.default; } });
